const b = (a, g = {}) => {
  const { logErrorCallback: l, onLoadCallback: c } = g, f = "en", s = "invalid languageId in localization-util", i = (e) => {
    const t = a[e];
    return t || (l ? l(`${s}.getValue: ${e}`) : console.error("Invalid locale for getValue:", e)), t;
  }, d = (e, t) => {
    const o = i(t);
    return Object.keys(o.values).find(
      (n) => o.values[n] === e
    );
  }, v = (e, t, o, n, ...r) => u(e === 1 ? t : o, n, ...r), p = () => {
    if (navigator && navigator.language) {
      const { language: e } = navigator, { region: t } = new Intl.Locale(e);
      return t ? t.toUpperCase() : void 0;
    }
    throw new Error("Browser does not support the Navigator interface");
  }, L = () => Object.keys(a).map((e) => ({ id: e, name: a[e].name })), u = (e, t, ...o) => {
    let n = "";
    const r = i(t);
    r || (l ? l(`${s}.getValue: ${t}`) : console.error("Invalid locale for getValue:", t));
    const V = a[f];
    return n = (r == null ? void 0 : r.values[e]) || V.values[e], o.forEach((_) => {
      n = n == null ? void 0 : n.replace("___", _);
    }), n || e;
  };
  return c && c(), {
    getKey: d,
    getPluralValue: v,
    getRegion: p,
    getSupportedLanguages: L,
    getValue: u
  };
};
export {
  b as default
};
